import type { ScreenFeatureResource } from '../transport'

import { actionButton } from './action-button'
import { appAvailability } from './app-availability'
import { attendance } from './attendance'
import { calendar } from './calendar'
import { call } from './call'
import { chat } from './chat'
import { classGrades } from './class-grades'
import { directory } from './directory'
import type { ScreenFeatureEntry } from './entry'
import { home } from './home'
import { parentAiChat } from './parent-ai-chat'
import { personDetail } from './person-detail'
import { resourceBoard } from './resource-board'
import { search } from './search'
import { sectionDetail } from './section-detail'
import { tabBar } from './tab-bar'

// Assembly only: each entry lives in its own file so units migrating different
// features never edit the same one.
export const registry = {
  chat,
  call,
  directory,
  personDetail,
  sectionDetail,
  home,
  calendar,
  attendance,
  classGrades,
  actionButton,
  appAvailability,
  resourceBoard,
  search,
  parentAiChat,
  tabBar
} satisfies Record<string, ScreenFeatureEntry<ScreenFeatureResource, any, any, any, any>>

export type ScreenFeatureName = keyof typeof registry

type EntryOf<N extends ScreenFeatureName> = (typeof registry)[N]
type ToWireOf<N extends ScreenFeatureName> = NonNullable<EntryOf<N>['toWire']>

export type ScreenFeatureValue<N extends ScreenFeatureName> = Parameters<ToWireOf<N>>[1]
export type ScreenFeatureChange<N extends ScreenFeatureName> = Parameters<ToWireOf<N>>[0]

/** The entries that accept `SYSTEM_DEFAULTS` (a fleet-default read and write). */
export type SystemScopedName = {
  [K in ScreenFeatureName]: EntryOf<K> extends { systemScope: true } ? K : never
}[ScreenFeatureName]
